import { USER_MANUAL_MASTER_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import React from "react";
import { Switch } from "react-router-dom";
import { authorizationService } from "services/common-services/authorization-service";
import UserManualMaster from "./UserManualMaster/UserManualMaster";

function UserManualView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={USER_MANUAL_MASTER_ROUTE}
        key={USER_MANUAL_MASTER_ROUTE}
        component={UserManualMaster}
        auth={auth(USER_MANUAL_MASTER_ROUTE)}
      />
    </Switch>
  );
}

export { UserManualMaster };
export default UserManualView;
